import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LsButtonComponent, LsModalComponent } from '@axess/ng-limestone';
import { TranslateModule } from '@ngx-translate/core';
import { HideTranslationPipe } from '@shared/pipes/hide-translation/hide-translation.pipe';
import { OverlayPortal } from '@ui/directives/overlay-portal';
import Bowser, { getParser } from 'bowser';

@Component({
  selector: 'app-browser-check',
  templateUrl: './browser-check.component.html',
  styleUrls: ['./browser-check.component.scss'],
  standalone: true,
  imports: [NgIf, TranslateModule, HideTranslationPipe, OverlayPortal, LsButtonComponent, LsModalComponent]
})
export class BrowserCheckComponent implements OnInit {
  isBrowserModalOpened = false;
  isBrowserModalCloseVisible = true;

  constructor() {}

  ngOnInit() {
    const browser = getParser(window.navigator.userAgent);

    let isValidBrowser = browser.satisfies({
      windows: {
        'internet explorer': '<1',
        'Microsoft Edge': '>1'
      },
      macos: {
        safari: '>10'
      },
      mobile: {
        safari: '>10',
        samsung_internet: '>8.0.00.90',
        'android browser': '>3.10'
      },
      chrome: '>58',
      firefox: '>51',
      opera: '>45',
      samsung_internet: '>8.0.00.90'
    });

    if (!isValidBrowser) {
      isValidBrowser = this.isValid_iOS_WebView(browser);
    }

    this.isBrowserModalOpened = !isValidBrowser;
    this.isBrowserModalCloseVisible = browser.getBrowserName() !== 'Internet Explorer';
  }

  isValid_iOS_WebView(browser: Bowser.Parser.Parser) {
    const { name: browserName } = browser.getBrowser();
    const { name: engineName } = browser.getEngine();
    const { name: osName } = browser.getOS();
    const { model: platformModel, type: platformType, vendor: platformVendor } = browser.getPlatform();

    const isSafariBrowser = browserName === 'Safari';
    const isBrowserEngineGeckoOrWebKit = engineName === 'Gecko' || engineName === 'WebKit';
    const isOSiOS = osName === 'iOS';
    const is_iPhone = platformModel === 'iPhone' && platformType === 'mobile';
    const is_iPad = platformModel === 'iPad' && platformType === 'tablet';
    const isApple = platformVendor === 'Apple';

    return isSafariBrowser && isBrowserEngineGeckoOrWebKit && isOSiOS && (is_iPhone || is_iPad) && isApple;
  }

  closeModalWindow($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();

    this.isBrowserModalOpened = false;
  }
}
